export default __webpack_public_path__ + "static/media/BTC-ON.c0faf6f7.png";